module.exports = __webpack_public_path__ + "img/banner-01.cb774826.jpg";